import { HistoryCheckItemsProps } from '../../../../../components/HubPages/components/GreenlightHistoryCheck/HistoryCheckItems/HistoryCheckItems.typed';
import { SectionBreakHeader } from '../../../../../components/HubPages/components/SectionBreakHeader/SectionBreakHeader';
import * as Styled from '../../../../../components/HubPages/components/GreenlightHistoryCheck/HistoryCheckItems/HistoryCheckItems.styled';
import { InfoTitle } from '../../../../../components/Toolkit/InfoTitle/InfoTitle';

export const HistoryCheckItems = (props: HistoryCheckItemsProps) => {
  const { items, title } = props;
  return items && title ? (
    <>
      {title && <SectionBreakHeader title={title} />}
      <Styled.Panel>
        {items.map((item) => {
          const title = item.title[0].text;
          const subtitle = item.subtitle[0].text;
          const iconHeight = item.icon.dimensions?.height || 32;
          const iconWidth = item.icon.dimensions?.width || 32;

          return (
            <InfoTitle
              variant={'SMALL'}
              key={title}
              title={title}
              description={subtitle}
              icon={
                <Styled.img
                  src={item.icon.url}
                  alt={title}
                  width={iconWidth}
                  height={iconHeight}
                />
              }
            />
          );
        })}
      </Styled.Panel>
    </>
  ) : null;
};
